{
  "nav": {
    "overview": "Overzicht",
    "budgets": "Budgetten"
  },
  "overview": {
    "title": "Studio-overzicht",
    "description": "Bouw agents, koppel modellen en tools en houd in de gaten wat ze doen.",
    "setup": {
      "title": "Aan de slag",
      "description": "Drie stappen naar je eerste werkende agent.",
      "provider": "Koppel een modelaanbieder",
      "model": "Voeg een model toe",
      "agent": "Maak je eerste agent"
    },
    "stats": {
      "agents": "Actieve agents",
      "archived_one": "{{count}} gearchiveerd",
      "archived_other": "{{count}} gearchiveerd",
      "runs7d": "Runs (7 dagen)",
      "models": "Modellen",
      "providers": "Aanbieders",
      "integrations": "Integraties",
      "skills": "Vaardigheden"
    },
    "recentRuns": "Recente runs",
    "noRuns": "Nog geen runs. Probeer een agent uit om hier de eerste run te zien.",
    "viewAll": "Alles bekijken",
    "budgets": "Budgetstatus",
    "noBudgets": "Geen budgetregels",
    "noBudgetsHint": "Begrens de uitgaven per organisatie of per agent.",
    "manage": "Beheren",
    "quickLinks": "Ga naar",
    "links": {
      "agents": "Instructies, modellen, tools en vaardigheden per agent.",
      "skills": "Herbruikbare instructies die agents laden wanneer nodig.",
      "mcp": "Koppel tools via MCP, met OAuth of headers.",
      "models": "Modellen, limieten en prijzen.",
      "providers": "API-endpoints en sleutels van modelleveranciers.",
      "runs": "Elke run met prompt, tools en kosten."
    }
  },
  "tags": {
    "title": "Labels",
    "manage": "Labels beheren",
    "manageDescription": "Labels groeperen agents en filteren de agentlijst. Hernoem ze of geef ze hier een andere kleur.",
    "searchOrCreate": "Zoek of maak een label…",
    "create": "“{{name}}” aanmaken",
    "none": "Nog geen labels",
    "empty": "Nog geen labels",
    "add": "Toevoegen",
    "name": "Labelnaam",
    "newPlaceholder": "Nieuw label, bijv. Support",
    "customColor": "Eigen kleur",
    "remove": "Label {{name}} verwijderen",
    "delete": "Label verwijderen",
    "deleteTitle": "Label “{{name}}” verwijderen?",
    "deleteDescription_one": "Het wordt van {{count}} agent gehaald. De agent zelf blijft bestaan.",
    "deleteDescription_other": "Het wordt van {{count}} agents gehaald. De agents zelf blijven bestaan.",
    "deleted": "Label “{{name}}” verwijderd",
    "agentCount_one": "Gebruikt door {{count}} agent",
    "agentCount_other": "Gebruikt door {{count}} agents"
  },
  "kv": {
    "key": "Naam",
    "value": "Waarde",
    "add": "Toevoegen",
    "remove": "Verwijderen",
    "duplicate": "Namen moeten uniek zijn."
  },
  "markdown": {
    "mode": "Weergave van de editor",
    "write": "Schrijven",
    "preview": "Voorbeeld",
    "split": "Naast elkaar",
    "nothing": "Nog niets om te tonen.",
    "stats": "{{chars}} tekens · ~{{tokens}} tokens"
  },
  "diff": {
    "identical": "Geen verschillen.",
    "lines": "regels gewijzigd",
    "unchanged_one": "{{count}} ongewijzigde regel",
    "unchanged_other": "{{count}} ongewijzigde regels",
    "added": "toegevoegd:",
    "removed": "verwijderd:",
    "field": "Instelling",
    "before": "Voor",
    "after": "Na"
  },
  "agents": {
    "title": "AI-agents",
    "description": "Bepaal wat elke agent weet, op welk model hij draait en welke tools hij mag gebruiken.",
    "editorTitle": "Agent bewerken",
    "backToList": "Alle agents",
    "new": "Nieuwe agent",
    "newTitle": "Nieuwe agent",
    "newDescription": "Geef een naam en een model op. De rest stel je daarna in.",
    "createAndConfigure": "Aanmaken en instellen",
    "defaultPrompt": "Je bent {{name}}, een behulpzame assistent. Antwoord helder en beknopt.",
    "search": "Agents zoeken…",
    "filterTag": "Filteren op label",
    "allTags": "Alle labels",
    "showArchived": "Gearchiveerde tonen",
    "clearFilters": "Filters wissen",
    "emptyFiltered": "Geen agents voor deze filters",
    "empty": {
      "title": "Nog geen agents",
      "description": "Maak je eerste agent en stel de instructies, het model, de tools en vaardigheden in.",
      "action": "Maak je eerste agent"
    },
    "noModels": {
      "title": "Voeg eerst een model toe",
      "description": "Agents draaien op een model. Koppel een aanbieder en registreer minstens één model.",
      "action": "Naar modellen"
    },
    "columns": {
      "agent": "Naam",
      "model": "Taalmodel",
      "tags": "Labels",
      "capabilities": "Tools & vaardigheden",
      "runs7d": "Runs (7 dagen)",
      "lastRun": "Laatste run"
    },
    "integrationCount_one": "{{count}} integratie",
    "integrationCount_other": "{{count}} integraties",
    "skillCount_one": "{{count}} vaardigheid",
    "skillCount_other": "{{count}} vaardigheden",
    "chatEnabled": "Beschikbaar in chat",
    "archivedBadge": "Gearchiveerd",
    "noDescription": "Geen beschrijving",
    "neverRun": "Nooit",
    "moreActions": "Meer acties",
    "actions": {
      "edit": "Bewerken",
      "try": "Uitproberen",
      "duplicate": "Dupliceren",
      "archive": "Archiveren",
      "unarchive": "Uit archief halen",
      "delete": "Verwijderen",
      "viewRuns": "Runs bekijken"
    },
    "created": "Agent “{{name}}” aangemaakt",
    "saved": "“{{name}}” opgeslagen",
    "duplicated": "“{{name}}” aangemaakt",
    "archived": "“{{name}}” gearchiveerd",
    "unarchived": "“{{name}}” teruggezet",
    "deleted": "“{{name}}” verwijderd",
    "archive": {
      "title": "“{{name}}” archiveren?",
      "description": "Gearchiveerde agents verdwijnen uit de chat en kunnen niet meer draaien. De geschiedenis blijft bewaard en je kunt ze altijd terugzetten.",
      "confirm": "Archiveren"
    },
    "delete": {
      "title": "“{{name}}” verwijderen?",
      "description": "De agent, zijn revisies en toolkoppelingen worden verwijderd. Eerdere runs blijven in het runlogboek staan.",
      "confirm": "Agent verwijderen",
      "blockedTitle": "“{{name}}” kan niet worden verwijderd",
      "archiveInstead": "Archiveren in plaats daarvan"
    },
    "leave": {
      "title": "Weggaan zonder op te slaan?",
      "description": "Je wijzigingen aan deze agent gaan verloren.",
      "confirm": "Wijzigingen weggooien",
      "stay": "Verder bewerken"
    },
    "tabs": {
      "configure": "Instellen",
      "tools": "Integraties",
      "skills": "Vaardigheden",
      "revisions": "Revisies"
    },
    "icon": {
      "change": "Pictogram wijzigen",
      "title": "Pictogram",
      "custom": "Een emoji naar keuze…",
      "use": "Gebruiken",
      "initials": "Initialen gebruiken"
    },
    "sections": {
      "identity": {
        "title": "Identiteit",
        "description": "Hoe mensen deze agent vinden en herkennen."
      },
      "instructions": {
        "title": "Instructies",
        "description": "De systeemprompt: rol, toon, regels en de kennis die de agent altijd nodig heeft."
      },
      "model": {
        "title": "Model en sampling",
        "description": "Welk model antwoordt en hoe voorspelbaar de antwoorden zijn."
      },
      "reasoning": {
        "title": "Redeneren",
        "description": "Laat het model nadenken voordat het antwoordt. Trager en duurder, maar beter bij lastige vragen."
      },
      "behaviour": {
        "title": "Gedrag",
        "description": "Waar de agent beschikbaar is, hoe lang hij mag doorwerken en hoe zijn prompt wordt gecachet."
      },
      "nav": "Onderdelen"
    },
    "fields": {
      "name": "Naam",
      "description": "Beschrijving",
      "descriptionHint": "Zichtbaar in de agentkeuze van de chat en gebruikt door andere agents om te bepalen wanneer ze delegeren.",
      "descriptionPlaceholder": "Waar deze agent goed in is…",
      "tags": "Labels",
      "addTag": "Label toevoegen",
      "model": "Taalmodel",
      "temperature": "Temperatuur",
      "temperatureHint": "{{hint}} Lager is gerichter en herhaalbaar, hoger is gevarieerder.",
      "temperatureFocused": "Gericht.",
      "temperatureBalanced": "Gebalanceerd.",
      "temperatureCreative": "Creatief.",
      "temperatureWild": "Erg willekeurig.",
      "topP": "Top-P",
      "topPHint": "Nucleus-sampling, 0–1.",
      "topK": "Top-K",
      "topKHint": "Kies uit de K meest waarschijnlijke tokens.",
      "topKUnsupported": "Niet ondersteund door OpenAI-modellen.",
      "maxTokens": "Max. uitvoer",
      "maxTokensHint": "Bovengrens per antwoord.",
      "tokensUnit": "tokens",
      "default": "Standaard",
      "thinking": "Uitgebreid nadenken",
      "thinkingHint": "Het model redeneert stap voor stap voordat het antwoordt. De redenering is zichtbaar in de chat en het runlogboek.",
      "effort": "Denkinspanning",
      "effortHint": "Hoeveel het model nadenkt voordat het antwoordt.",
      "effortDisabled": "Zet uitgebreid nadenken aan om een inspanning te kiezen.",
      "chatAgent": "Beschikbaar in chat",
      "chatAgentHint": "Leden kunnen deze agent kiezen in Chat (afhankelijk van hun chatagent-rechten).",
      "maxSteps": "Max. stappen",
      "maxStepsHint": "Modelaanroepen per run, inclusief toolgebruik.",
      "stepsUnit": "stappen",
      "cacheStatic": "Instructies & tools cachen",
      "cacheStaticHint": "Hoe lang de systeemprompt en de toollijst in de cache blijven.",
      "cacheMessages": "Gesprek cachen",
      "cacheMessagesHint": "Hoe lang eerdere berichten in de cache blijven.",
      "cacheAnthropicOnly": "Cache-instellingen worden alleen door Anthropic-modellen gebruikt."
    },
    "effort": {
      "low": "Laag",
      "medium": "Gemiddeld",
      "high": "Hoog",
      "xhigh": "Extra hoog",
      "max": "Maximaal"
    },
    "cache": {
      "5m": "5 minuten",
      "1h": "1 uur"
    },
    "model": {
      "manage": "Modellen beheren",
      "context": "{{n}} aan context",
      "price": "{{input}} in / {{output}} uit per 1M",
      "fallback": "Valt terug op {{name}}"
    },
    "prompt": {
      "placeholder": "Je bent een behulpzame assistent voor…",
      "stats_one": "{{lines}} regel · {{chars}} tekens · ~{{tokens}} tokens",
      "stats_other": "{{lines}} regels · {{chars}} tekens · ~{{tokens}} tokens",
      "expand": "Editor vergroten",
      "collapse": "Editor verkleinen"
    },
    "save": {
      "note": "Revisienotitie",
      "notePlaceholder": "Wat is er veranderd? (optioneel, wordt bij de revisie bewaard)",
      "invalid": "Herstel de gemarkeerde velden om op te slaan.",
      "fields": {
        "name": "Naam",
        "description": "Beschrijving",
        "icon": "Pictogram",
        "model_id": "Taalmodel",
        "system_prompt": "Instructies",
        "temperature": "Temperatuur",
        "top_p": "Top-P",
        "top_k": "Top-K",
        "max_tokens": "Max. uitvoer",
        "thinking_enabled": "Nadenken",
        "reasoning_effort": "Denkinspanning",
        "prompt_cache_static": "Instructiecache",
        "prompt_cache_messages": "Gesprekscache",
        "max_steps": "Max. stappen",
        "allow_as_chat_agent": "Beschikbaarheid in chat",
        "tag_ids": "Labels",
        "skill_ids": "Vaardigheden",
        "mcp_servers": "Integraties"
      }
    },
    "tools": {
      "title": "Integraties",
      "description": "Kies welke MCP-integraties en ingebouwde toolsets deze agent mag gebruiken en zet losse tools uit.",
      "searchIntegrations": "Integraties zoeken…",
      "manage": "Integraties beheren",
      "assign": "{{name}} gebruiken",
      "configure": "Tools kiezen",
      "all": "Alle tools",
      "enabledCount": "{{enabled}} van {{total}} aan",
      "search": "Tools zoeken…",
      "listLabel": "Tools van {{name}}",
      "notAllowed": "Uit voor de organisatie",
      "orgLimited_one": "{{count}} tool staat voor de hele organisatie uit in de instellingen van de integratie.",
      "orgLimited_other": "{{count}} tools staan voor de hele organisatie uit in de instellingen van de integratie.",
      "someDisabled_one": "{{count}} tool uit",
      "someDisabled_other": "{{count}} tools uit",
      "noTools": "Deze integratie biedt geen tools aan.",
      "loadFailed": "De tools konden niet worden geladen",
      "orphaned_one": "{{count}} gekoppelde integratie bestaat niet meer.",
      "orphaned_other": "{{count}} gekoppelde integraties bestaan niet meer.",
      "removeOrphaned": "Verwijderen",
      "empty": {
        "title": "Nog geen integraties",
        "description": "Koppel een MCP-server om agents tools te geven, zoals zoeken, tickets of agenda's.",
        "action": "Integratie toevoegen"
      }
    },
    "skills": {
      "title": "Vaardigheden",
      "description": "Vaardigheden zijn instructies die de agent pas laadt als hij ze nodig heeft. Zo blijft de prompt klein.",
      "applyPreset": "Voorkeuzeset toevoegen…",
      "manage": "Vaardigheden beheren",
      "search": "Vaardigheden zoeken…",
      "selectedCount_one": "{{count}} geselecteerd",
      "selectedCount_other": "{{count}} geselecteerd",
      "previewEmpty": "Kies een vaardigheid om die te bekijken",
      "empty": {
        "title": "Nog geen vaardigheden",
        "description": "Schrijf of importeer vaardigheden in de bibliotheek en koppel ze hier.",
        "action": "Naar de bibliotheek"
      }
    },
    "revisions": {
      "hint": "Er wordt een revisie bewaard zodra het model, de instructies of de sampling veranderen.",
      "current": "Huidig",
      "untitled": "Revisie #{{id}}",
      "savedBy": "{{date}} door {{user}}",
      "system": "het systeem",
      "compareWith": "Vergelijken met",
      "vsPrevious": "vs. vorige",
      "vsCurrent": "vs. huidige",
      "restore": "Terugzetten",
      "restoreTitle": "Deze revisie terugzetten?",
      "restoreDescription": "De agent krijgt weer het model, de instructies en de sampling van {{date}}. Er wordt een nieuwe revisie gemaakt, dus er gaat niets verloren.",
      "restoreDiscards": "Je niet-opgeslagen wijzigingen worden weggegooid.",
      "restored": "Revisie teruggezet",
      "first": "Dit is de eerste revisie.",
      "settings": "Instellingen",
      "noSettingChanges": "Geen gewijzigde instellingen.",
      "prompt": "Instructies",
      "fields": {
        "model": "Taalmodel",
        "temperature": "Temperatuur",
        "top_p": "Top-P",
        "top_k": "Top-K",
        "max_tokens": "Max. uitvoer",
        "thinking_enabled": "Nadenken",
        "reasoning_effort": "Denkinspanning",
        "max_steps": "Max. stappen",
        "description": "Beschrijving"
      },
      "empty": {
        "title": "Nog geen revisies",
        "description": "Revisies verschijnen zodra het model, de instructies of de sampling veranderen."
      }
    },
    "try": {
      "button": "Uitproberen",
      "title": "Uitproberen",
      "description": "Chat met deze agent met de instellingen uit de editor, opgeslagen of niet. Testgesprekken komen niet in de chatgeschiedenis.",
      "emptyTitle": "Praat met {{name}}",
      "placeholder": "Bericht aan de agent…",
      "send": "Versturen",
      "stop": "Stoppen",
      "reset": "Nieuw gesprek",
      "close": "Sluiten",
      "thinking": "Denkt na…",
      "reasoning": "Redenering",
      "working": "Bezig…",
      "failed": "De run is mislukt.",
      "cancelled": "Gestopt.",
      "fixErrors": "Herstel eerst de fouten in de editor.",
      "openRun": "Run openen",
      "tokens": "tokens: {{n}}",
      "unsaved": "Niet-opgeslagen instellingen",
      "unsavedHint": "Antwoorden gebruiken de instructies, het model, de sampling, het nadenken, de cache, vaardigheden en integraties uit de editor, ook vóór het opslaan.",
      "ignored": "Denkinspanning, uitvoerlimiet, max. stappen en schakelaars per tool gelden pas na opslaan.",
      "starters": {
        "intro": "Stel jezelf voor in twee zinnen.",
        "capabilities": "Waarmee kun je me helpen?",
        "tools": "Welke tools heb je tot je beschikking?"
      }
    }
  },
  "providers": {
    "title": "Aanbieders",
    "description": "Endpoints en API-sleutels van de modelleveranciers die je agents gebruiken. Sleutels worden versleuteld en nooit meer getoond.",
    "new": "Aanbieder toevoegen",
    "newTitle": "Modelaanbieder toevoegen",
    "editTitle": "{{name}} bewerken",
    "formDescription": "Anthropic, OpenAI, een OpenAI-compatibele gateway (vLLM, LiteLLM, Azure…) of Ollama.",
    "create": "Aanbieder toevoegen",
    "search": "Aanbieders zoeken…",
    "defaultEndpoint": "Standaard-endpoint",
    "noKey": "Geen sleutel",
    "created": "Aanbieder “{{name}}” toegevoegd",
    "updated": "Aanbieder “{{name}}” opgeslagen",
    "deleted": "Aanbieder “{{name}}” verwijderd",
    "delete": "Aanbieder verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "De opgeslagen API-sleutel en headers worden verwijderd.",
    "deleteInUse_one": "{{count}} model gebruikt deze aanbieder nog. Verwijder of verplaats het eerst.",
    "deleteInUse_other": "{{count}} modellen gebruiken deze aanbieder nog. Verwijder of verplaats ze eerst.",
    "empty": {
      "title": "Nog geen aanbieders",
      "description": "Koppel Anthropic, OpenAI, een OpenAI-compatibel endpoint of Ollama om modellen toe te voegen."
    },
    "columns": {
      "name": "Aanbieder",
      "kind": "Soort",
      "apiKey": "API-sleutel",
      "models": "Modellen",
      "status": "Verbinding",
      "updated": "Bijgewerkt"
    },
    "kinds": {
      "openai_compatible": "OpenAI-compatibel"
    },
    "kindHints": {
      "anthropic": "Claude-modellen via de Anthropic-API.",
      "openai": "GPT-modellen via de OpenAI-API.",
      "openai_compatible": "vLLM, LiteLLM, Azure OpenAI, OpenRouter en andere gateways.",
      "ollama": "Lokale modellen via Ollama."
    },
    "form": {
      "name": "Naam",
      "kind": "Soort",
      "baseUrl": "Basis-URL",
      "baseUrlHint": "Laat leeg voor het standaard-endpoint van de leverancier.",
      "baseUrlHintCompat": "Eindigt meestal op /v1. Gebruik vanuit Docker host.docker.internal in plaats van localhost.",
      "baseUrlRequired": "Voor dit soort aanbieder is een basis-URL verplicht.",
      "apiKey": "API-sleutel",
      "apiKeyHint": "Wordt versleuteld opgeslagen. Daarna zijn alleen de laatste tekens zichtbaar.",
      "apiKeyStored": "Er is een sleutel opgeslagen. Vul een nieuwe in om die te vervangen.",
      "apiKeyKeep": "Huidige sleutel behouden ({{hint}})",
      "apiKeyOptional": "Optioneel",
      "clearKey": "Opgeslagen sleutel verwijderen",
      "strict": "Strikte OpenAI-compatibiliteit",
      "strictHint": "Stuur alleen de breedst ondersteunde parameters mee (aanbevolen voor Ollama en oudere gateways).",
      "headers": "Eigen headers",
      "headersHint": "Gaan mee met elk verzoek, bijv. een API-versie of organisatieheader. Waarden zijn alleen te schrijven.",
      "noHeaders": "Geen eigen headers",
      "replaceHeaders": "Headers vervangen",
      "addHeader": "Header toevoegen"
    },
    "test": {
      "action": "Verbinding testen",
      "title": "Verbinding",
      "hint": "Controleert het endpoint en de sleutel door de beschikbare modellen op te vragen.",
      "running": "Verbinden…",
      "ok_one": "{{name}} antwoordde in {{ms}} ms met {{count}} model.",
      "ok_other": "{{name}} antwoordde in {{ms}} ms met {{count}} modellen.",
      "failed": "{{name}} is niet bereikbaar",
      "online": "Bereikbaar · {{ms}} ms",
      "offline": "Onbereikbaar"
    },
    "import": {
      "action": "Modellen importeren",
      "title": "Modellen importeren van {{name}}",
      "description": "Kies de modellen die je wilt gebruiken. Modellen die al geregistreerd zijn, zijn gemarkeerd.",
      "search": "Modellen filteren…",
      "summary": "{{total}} gevonden · {{fresh}} nieuw",
      "selectAll": "Alle nieuwe modellen selecteren",
      "added": "Toegevoegd",
      "empty": "Deze aanbieder meldt geen modellen.",
      "failed": "De modellen van de aanbieder konden niet worden opgehaald",
      "submit_one": "{{count}} model importeren",
      "submit_other": "{{count}} modellen importeren",
      "done_one": "{{count}} model geïmporteerd",
      "done_other": "{{count}} modellen geïmporteerd"
    }
  },
  "models": {
    "title": "Modellen",
    "description": "De modellen waarop agents kunnen draaien, met hun limieten, terugvalopties en prijzen voor de kostenberekening.",
    "new": "Model toevoegen",
    "newTitle": "Model toevoegen",
    "editTitle": "{{name}} bewerken",
    "formDescription": "Registreer een model van een van je aanbieders.",
    "create": "Model toevoegen",
    "search": "Modellen zoeken…",
    "importFrom": "Importeren",
    "chooseProvider": "Van aanbieder",
    "allProviders": "Alle aanbieders",
    "vision": "Beeldherkenning",
    "tools": "Toolgebruik",
    "noPrice": "Geen prijs",
    "limits": "{{ctx}} ctx · {{output}} uit",
    "fallbackShort": "terugval: {{name}}",
    "created": "Model “{{name}}” toegevoegd",
    "updated": "Model “{{name}}” opgeslagen",
    "deleted": "Model “{{name}}” verwijderd",
    "delete": "Model verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "De prijsgeschiedenis wordt ook verwijderd.",
    "deleteInUse_one": "{{count}} agent draait op dit model. Zet die eerst op een ander model.",
    "deleteInUse_other": "{{count}} agents draaien op dit model. Zet ze eerst op een ander model.",
    "noProviders": {
      "title": "Koppel eerst een aanbieder",
      "description": "Modellen horen bij een aanbieder. Voeg Anthropic, OpenAI, een OpenAI-compatibel endpoint of Ollama toe."
    },
    "empty": {
      "title": "Nog geen modellen",
      "description": "Voeg een model handmatig toe of importeer er meerdere tegelijk van een aanbieder."
    },
    "columns": {
      "model": "Taalmodel",
      "provider": "Aanbieder",
      "limits": "Limieten",
      "capabilities": "Mogelijkheden",
      "price": "Prijs per 1M (in / uit)",
      "agents": "Gebruikt door"
    },
    "form": {
      "provider": "Aanbieder",
      "model": "Model-ID",
      "modelHint": "Precies zoals de API van de aanbieder het verwacht.",
      "name": "Weergavenaam",
      "nameHint": "Standaard de model-ID.",
      "description": "Beschrijving",
      "fallback": "Terugvalmodel",
      "fallbackHint": "Wordt automatisch gebruikt als dit model niet beschikbaar of overbelast is.",
      "noFallback": "Geen terugvalmodel",
      "context": "Contextvenster",
      "maxOutput": "Max. uitvoer",
      "visionHint": "Accepteert afbeeldingen en pdf's.",
      "toolsHint": "Kan tools aanroepen (MCP-integraties, vaardigheden)."
    },
    "prices": {
      "title": "Prijzen",
      "description": "Elke prijs geldt vanaf de ingangsdatum. Eerdere runs houden de prijs die toen gold.",
      "initialHint": "Optioneel. Wordt gebruikt om de kosten van runs en budgetten te berekenen.",
      "add": "Prijs toevoegen",
      "newTitle": "Nieuwe prijs",
      "editTitle": "Prijs bewerken",
      "dialogDescription": "Prijzen zijn per miljoen tokens. Met een nieuwe ingangsdatum blijft de prijsgeschiedenis intact.",
      "empty": "Nog geen prijzen. Runs op dit model tonen geen kosten.",
      "current": "Actueel",
      "scheduled": "Gepland",
      "input": "Invoerprijs",
      "output": "Uitvoerprijs",
      "inputShort": "Invoer",
      "outputShort": "Uitvoer",
      "cacheRead": "Cache lezen",
      "cacheWrite": "Cache schrijven",
      "cacheShort": "Cache l/s",
      "per1m": "/ 1M",
      "currency": "Valuta",
      "effectiveFrom": "Ingangsdatum",
      "effectiveFromHint": "De prijs geldt voor runs vanaf deze datum.",
      "created": "Prijs toegevoegd",
      "updated": "Prijs opgeslagen",
      "deleted": "Prijs verwijderd",
      "delete": "Prijs verwijderen",
      "deleteTitle": "Deze prijs verwijderen?",
      "deleteDescription": "De prijs die geldt vanaf {{date}} wordt verwijderd. Kosten van nieuwe runs vallen terug op de vorige prijs."
    }
  },
  "skills": {
    "title": "Vaardigheden",
    "description": "Herbruikbare instructies die agents laden als een taak erom vraagt. Schrijf ze hier, upload SKILL.md-bestanden of synchroniseer een Git-repository.",
    "tabs": {
      "skills": "Bibliotheek",
      "presets": "Voorkeuzesets"
    },
    "new": "Nieuwe vaardigheid",
    "newTitle": "Nieuwe vaardigheid",
    "formDescription": "Beschrijf wanneer de vaardigheid van pas komt en schrijf de instructies in Markdown.",
    "create": "Vaardigheid aanmaken",
    "import": "Importeren",
    "importFile": "Uit Markdown-bestand…",
    "importGit": "Uit GitHub-repository…",
    "imported": "Vaardigheid “{{name}}” geïmporteerd",
    "search": "Vaardigheden zoeken…",
    "noDescription": "Geen beschrijving",
    "manual": "Hier geschreven",
    "disabled": "Uitgeschakeld",
    "chars": "{{n}} tekens",
    "toggle": "{{name}} inschakelen",
    "download": ".md downloaden",
    "emptyBody": "Deze vaardigheid heeft nog geen instructies.",
    "fromGit": "Gesynchroniseerd uit {{repo}} ({{branch}}) · {{path}}. Opnieuw importeren overschrijft lokale wijzigingen.",
    "created": "Vaardigheid “{{name}}” aangemaakt",
    "updated": "Vaardigheid “{{name}}” opgeslagen",
    "deleted": "Vaardigheid “{{name}}” verwijderd",
    "delete": "Vaardigheid verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "De vaardigheid verdwijnt uit de bibliotheek.",
    "deleteInUse_one": "{{count}} agent gebruikt deze vaardigheid en kan die dan niet meer laden.",
    "deleteInUse_other": "{{count}} agents gebruiken deze vaardigheid en kunnen die dan niet meer laden.",
    "empty": {
      "title": "Nog geen vaardigheden",
      "description": "Met vaardigheden blijven lange instructies buiten de prompt tot een agent ze nodig heeft."
    },
    "columns": {
      "skill": "Vaardigheid",
      "source": "Bron",
      "agents": "Gebruikt door",
      "size": "Omvang",
      "updated": "Bijgewerkt",
      "enabled": "Ingeschakeld"
    },
    "form": {
      "name": "Naam",
      "slug": "Korte naam (slug)",
      "slugPlaceholder": "gemaakt-uit-de-naam",
      "slugHint": "Vaste aanduiding waarmee de agent de vaardigheid laadt.",
      "description": "Wanneer gebruiken",
      "descriptionHint": "Agents lezen deze regel om te bepalen of ze de vaardigheid laden. Wees specifiek.",
      "enabled": "Ingeschakeld",
      "enabledHint": "Uitgeschakelde vaardigheden zijn voor alle agents verborgen.",
      "body": "Instructies",
      "bodyHint": "Markdown. Stappen, regels, voorbeelden en sjablonen.",
      "bodyPlaceholder": "# Stappen\n1. …"
    },
    "git": {
      "title": "Importeren uit GitHub",
      "description": "Elk SKILL.md-bestand in de repository wordt een vaardigheid. Vaardigheden met dezelfde naam worden bijgewerkt.",
      "repo": "Repository-URL",
      "urlInvalid": "Gebruik een URL zoals https://github.com/eigenaar/repo",
      "branch": "Tak (branch)",
      "path": "Map",
      "pathHint": "Alleen onder dit pad importeren.",
      "disableMissing": "Verwijderde vaardigheden uitschakelen",
      "disableMissingHint": "Vaardigheden uit deze repository en branch die niet meer bestaan, worden uitgeschakeld.",
      "submit": "Importeren",
      "again": "Opnieuw importeren",
      "close": "Sluiten",
      "done_one": "{{count}} vaardigheid geïmporteerd",
      "done_other": "{{count}} vaardigheden geïmporteerd",
      "nothing": "Geen SKILL.md-bestanden gevonden.",
      "imported_one": "{{count}} geïmporteerd",
      "imported_other": "{{count}} geïmporteerd",
      "disabled_one": "{{count}} uitgeschakeld",
      "disabled_other": "{{count}} uitgeschakeld",
      "errors_one": "{{count}} mislukt",
      "errors_other": "{{count}} mislukt"
    },
    "presets": {
      "new": "Nieuwe voorkeuzeset",
      "newTitle": "Nieuwe voorkeuzeset",
      "editTitle": "{{name}} bewerken",
      "dialogDescription": "Een voorkeuzeset is een benoemde groep vaardigheden die je in één keer aan een agent toevoegt.",
      "name": "Naam",
      "descriptionField": "Beschrijving",
      "skills": "Vaardigheden",
      "selected_one": "{{count}} vaardigheid geselecteerd",
      "selected_other": "{{count}} vaardigheden geselecteerd",
      "noSkills": "Geen vaardigheden",
      "created": "Voorkeuzeset “{{name}}” aangemaakt",
      "updated": "Voorkeuzeset “{{name}}” opgeslagen",
      "deleted": "Voorkeuzeset “{{name}}” verwijderd",
      "delete": "Voorkeuzeset verwijderen",
      "deleteTitle": "Voorkeuzeset “{{name}}” verwijderen?",
      "deleteDescription": "Agents houden de vaardigheden die ze al hebben.",
      "empty": {
        "title": "Nog geen voorkeuzesets",
        "description": "Bundel vaardigheden die bij elkaar horen, zoals “Basis support”, en pas ze in één keer toe op agents."
      }
    }
  },
  "mcp": {
    "title": "MCP-integraties",
    "description": "Tools voor je agents via het Model Context Protocol, plus de ingebouwde toolsets van het platform.",
    "new": "Integratie toevoegen",
    "newTitle": "Integratie toevoegen",
    "formDescription": "Koppel een externe MCP-server via HTTP. Authenticeer met headers of OAuth.",
    "create": "Integratie toevoegen",
    "search": "Integraties zoeken…",
    "noDescription": "Geen beschrijving",
    "builtin": "Ingebouwd",
    "system": "Systeem",
    "disabled": "Uitgeschakeld",
    "enable": "Inschakelen",
    "disable": "Uitschakelen",
    "lockedBuiltin": "Ingebouwde toolsets draaien binnen het platform. Je kunt ze hernoemen, hun tools beperken en instructies toevoegen.",
    "lockedSystem": "Deze integratie wordt door het systeem beheerd; de verbindingsinstellingen zijn niet te wijzigen.",
    "stdioAdminOnly": "Opdrachtregel-integraties (stdio) starten processen op de server en kunnen alleen door platformbeheerders worden bewerkt.",
    "created": "Integratie “{{name}}” toegevoegd",
    "updated": "Integratie “{{name}}” opgeslagen",
    "deleted": "Integratie “{{name}}” verwijderd",
    "delete": "Integratie verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "Opgeslagen inloggegevens en tokens worden verwijderd.",
    "deleteInUse_one": "{{count}} agent gebruikt deze integratie en raakt de tools kwijt.",
    "deleteInUse_other": "{{count}} agents gebruiken deze integratie en raken de tools kwijt.",
    "toolCount_one": "tools: {{count}}",
    "toolCount_other": "tools: {{count}}",
    "empty": {
      "title": "Nog geen integraties",
      "description": "Voeg een MCP-server toe om agents tools te geven, zoals zoeken, tickets, bestanden of agenda's."
    },
    "columns": {
      "integration": "Integratie",
      "type": "Soort",
      "auth": "Authenticatie",
      "status": "Toestand",
      "tools": "Aantal tools",
      "agents": "Gebruikt door"
    },
    "status": {
      "enabled": "Ingeschakeld",
      "disabled": "Uitgeschakeld",
      "error": "Fout"
    },
    "tabs": {
      "connection": "Verbinding",
      "tools": "Toolselectie",
      "instructions": "Instructies"
    },
    "transport": {
      "http": "HTTP (streaming / SSE)",
      "httpHint": "Een externe MCP-server die via HTTPS bereikbaar is.",
      "stdio": "Opdrachtregel (stdio)",
      "stdioHint": "Start een lokaal proces op de server.",
      "stdioAdminOnly": "Alleen voor platformbeheerders."
    },
    "auth": {
      "none": "Geen",
      "headers": "Vaste headers",
      "oauth": "Via OAuth 2.0"
    },
    "form": {
      "name": "Naam",
      "enabled": "Ingeschakeld",
      "description": "Beschrijving",
      "transport": "Verbindingstype",
      "url": "Server-URL",
      "command": "Opdracht",
      "args": "Argumenten",
      "argsHint": "Eén argument per regel.",
      "env": "Omgevingsvariabelen",
      "envHint": "Worden aan het proces meegegeven. Waarden zijn alleen te schrijven.",
      "auth": "Authenticatie",
      "headers": "HTTP-headers",
      "headersHint": "Bijvoorbeeld Authorization: Bearer …. Waarden worden versleuteld en zijn alleen te schrijven.",
      "prefix": "Toolvoorvoegsel",
      "prefixHint": "Wordt voor de toolnamen gezet (voorvoegsel__tool) om botsingen tussen integraties te voorkomen.",
      "prefixInvalid": "Gebruik alleen letters, cijfers en underscores.",
      "instructions": "Instructies voor agents",
      "instructionsHint": "Worden toegevoegd aan de systeemprompt van agents die deze integratie gebruiken: wanneer welke tool, afspraken, beperkingen."
    },
    "oauth": {
      "title": "OAuth 2.0-koppeling",
      "needed": "Autoriseren",
      "expired": "Token verlopen",
      "expires": "Verloopt",
      "status": {
        "authorized": "Geautoriseerd",
        "expired": "Verlopen",
        "not_configured": "Niet geautoriseerd"
      },
      "discover": "Endpoints opzoeken",
      "discovered": "OAuth-endpoints ingevuld",
      "clientId": "Client-ID",
      "clientIdHint": "Laat leeg om automatisch te registreren (dynamische clientregistratie).",
      "clientSecret": "Clientgeheim",
      "secretKeep": "Huidig geheim behouden",
      "authorizationUrl": "Autorisatie-URL",
      "tokenUrl": "Token-URL",
      "registrationUrl": "Registratie-URL",
      "resource": "Bron (RFC 8707)",
      "scopes": "Bereik (scopes)",
      "scopesHint": "Gescheiden door spaties.",
      "saveFirst": "Sla de integratie op en autoriseer haar daarna.",
      "saveChangesFirst": "Sla je wijzigingen op voordat je autoriseert.",
      "authorizeHint": "Meld je in een pop-upvenster aan bij de dienst om toegang te geven.",
      "waiting": "Wachten tot je klaar bent in de pop-up…",
      "authorize": "Autoriseren",
      "reauthorize": "Opnieuw autoriseren",
      "revoke": "Intrekken",
      "revoked": "Toegang voor “{{name}}” ingetrokken",
      "success": "“{{name}}” is geautoriseerd",
      "error": "Autorisatie mislukt",
      "discoverFailed": "OAuth-endpoints niet gevonden"
    },
    "test": {
      "action": "Verbinding testen",
      "title": "Verbindingstest",
      "hint": "Maakt verbinding met de server en haalt de tools op.",
      "running": "Verbinden…",
      "cached_one": "{{count}} tool bewaard van de laatste test.",
      "cached_other": "{{count}} tools bewaard van de laatste test.",
      "ok_one": "Verbonden in {{ms}} ms · {{count}} tool",
      "ok_other": "Verbonden in {{ms}} ms · {{count}} tools",
      "okNamed_one": "{{name}}: verbonden in {{ms}} ms, {{count}} tool",
      "okNamed_other": "{{name}}: verbonden in {{ms}} ms, {{count}} tools",
      "failed": "De verbinding is mislukt.",
      "failedNamed": "Geen verbinding met {{name}}",
      "needsAuth": "De server vraagt om autorisatie. Autoriseer haar in de verbindingsinstellingen.",
      "online": "Verbonden",
      "offline": "Mislukt",
      "seeTools": "Kies welke tools agents mogen gebruiken onder"
    },
    "tools": {
      "all": "Alle tools",
      "allHint": "Nieuwe tools op de server komen automatisch beschikbaar.",
      "selected": "Alleen gekozen tools",
      "selectedHint": "Agents kunnen alleen de tools gebruiken die je aanvinkt.",
      "countAll_one": "tools: {{count}}",
      "countAll_other": "tools: {{count}}",
      "readOnly": "Alleen lezen",
      "destructive": "Ingrijpend",
      "unavailable": "Test de verbinding om de toollijst te laden."
    }
  },
  "budgets": {
    "title": "Budgetten",
    "description": "Begrens wat de organisatie of één agent per dag, week of maand mag uitgeven.",
    "new": "Nieuwe regel",
    "newTitle": "Nieuwe budgetregel",
    "editTitle": "Budgetregel bewerken",
    "dialogDescription": "De uitgaven zijn de kosten van runs in de huidige periode, op basis van de modelprijzen.",
    "statusTitle": "Deze periode",
    "statusDescription": "Uitgaven tot nu toe per limiet.",
    "policiesTitle": "Regels",
    "alertsTitle": "Meldingen",
    "alertsDescription": "Ontstaan wanneer de uitgaven de waarschuwingsdrempel van een regel passeren.",
    "noAlerts": "Nog geen meldingen",
    "unnamed": "Regel #{{id}}",
    "ofLimit": "van {{limit}}",
    "resets": "begint opnieuw {{when}}",
    "created": "Budgetregel aangemaakt",
    "updated": "Budgetregel opgeslagen",
    "deleted": "Budgetregel verwijderd",
    "delete": "Regel verwijderen",
    "deleteTitle": "Deze budgetregel verwijderen?",
    "deleteDescription": "De uitgaven worden niet langer door deze regel begrensd. Eerdere meldingen worden verwijderd.",
    "empty": {
      "title": "Nog geen budgetten",
      "description": "Zonder regel zijn de uitgaven onbeperkt. Voeg er een toe per organisatie of per agent."
    },
    "columns": {
      "policy": "Regel",
      "period": "Periode",
      "limit": "Limiet",
      "threshold": "Waarschuwen bij",
      "action": "Bij overschrijding",
      "enabled": "Actief"
    },
    "scope": {
      "tenant": "Hele organisatie",
      "agent": "Eén agent"
    },
    "period": {
      "day": "Per dag",
      "week": "Per week",
      "month": "Per maand"
    },
    "action": {
      "block": "Runs blokkeren",
      "blockHint": "Nieuwe runs worden geweigerd zodra de limiet is bereikt.",
      "warn": "Alleen waarschuwen",
      "warnHint": "Runs gaan door; er wordt een melding vastgelegd."
    },
    "level": {
      "ok": "Op koers",
      "warning": "Bijna op",
      "exceeded": "Overschreden",
      "blocked": "Blokkeert",
      "off": "Gepauzeerd"
    },
    "form": {
      "name": "Naam",
      "namePlaceholder": "bijv. Maandlimiet",
      "scope": "Geldt voor",
      "agent": "Welke agent",
      "period": "Periode",
      "limit": "Uitgavenlimiet",
      "limitHint": "In de valuta van je modelprijzen.",
      "threshold": "Waarschuwen bij",
      "thresholdHint": "Percentage van de limiet waarbij een melding ontstaat.",
      "action": "Als de limiet is bereikt",
      "enabled": "Regel actief"
    }
  },
  "copy": {
    "action": "Configuratie kopiëren",
    "rowAction": "Studio-configuratie hierheen kopiëren…",
    "title": "Configuratie kopiëren",
    "description": "Kopieer aanbieders, modellen, vaardigheden, integraties en agents naar een andere organisatie.",
    "from": "Van",
    "to": "Naar",
    "what": "Wat kopiëren",
    "note": "Afhankelijkheden gaan automatisch mee (een agent neemt zijn model en aanbieder mee). Wat in de doelorganisatie al bestaat met dezelfde naam wordt hergebruikt, nooit overschreven. API-sleutels worden meegekopieerd; OAuth-autorisaties niet.",
    "noTargets": "Je moet eigenaar of beheerder zijn van een andere organisatie.",
    "submit": "Kopiëren",
    "close": "Klaar",
    "done": "Gekopieerd van {{source}} naar {{target}}.",
    "nothing": "Niets om te kopiëren.",
    "collection": "Soort",
    "created": "Aangemaakt",
    "reused": "Bestond al",
    "collections": {
      "model_providers": "Modelaanbieders",
      "models": "Modellen & prijzen",
      "skills": "Vaardigheden",
      "mcp_servers": "MCP-integraties",
      "agents": "AI-agents",
      "agent_automations": "Agentautomatiseringen"
    },
    "hints": {
      "model_providers": "Endpoints, API-sleutels en headers.",
      "models": "Modellen met limieten, terugvalopties en prijsgeschiedenis.",
      "skills": "De vaardighedenbibliotheek.",
      "mcp_servers": "Integratie-instellingen en inloggegevens, zonder OAuth-tokens.",
      "agents": "Agents met hun labels, vaardigheden en integraties.",
      "agent_automations": "Automatiseringen met hun parameters."
    }
  },
  "connectors": {
    "title": "Connectoren",
    "description": "Breng agents naar chatplatformen. Elke connector meldt zich aan als botaccount en laat één agent de berichten beantwoorden.",
    "new": "Nieuwe connector",
    "search": "Connectoren zoeken…",
    "columns": {
      "connector": "Koppeling",
      "agent": "Gekoppelde agent",
      "status": "Toestand",
      "enabled": "Actief",
      "updated": "Bijgewerkt"
    },
    "noAgent": "Geen agent",
    "state": {
      "unavailable": "Niet beschikbaar",
      "disabled": "Uitgeschakeld",
      "noAgent": "Geen agent",
      "connected": "Verbonden",
      "starting": "Verbinden",
      "error": "Fout",
      "stopped": "Draait niet"
    },
    "stateHint": {
      "unavailable": "{{type}}-connectoren zijn nog niet beschikbaar.",
      "disabled": "Uitgeschakeld. Schakel in om naar berichten te luisteren.",
      "noAgent": "Koppel een agent om deze connector te starten.",
      "stopped": "Ingeschakeld, maar draait nog niet. Hij start binnen enkele seconden."
    },
    "statusSince": "sinds",
    "enableBlocked": "Koppel eerst een agent",
    "actions": {
      "test": "Verbinding testen",
      "enable": "Inschakelen",
      "disable": "Uitschakelen",
      "delete": "Verwijderen",
      "conversations": "Gesprekken"
    },
    "delete": {
      "title": "{{name}} verwijderen?",
      "description": "De bot stopt direct met antwoorden. Het gespreksgeheugen en de geüploade bestanden van de connector worden ook verwijderd. De rungeschiedenis blijft in Inzichten.",
      "confirm": "Connector verwijderen"
    },
    "toast": {
      "created": "Connector {{name}} aangemaakt",
      "updated": "Connector {{name}} opgeslagen",
      "deleted": "Connector {{name}} verwijderd",
      "enabled": "{{name}} ingeschakeld",
      "disabled": "{{name}} uitgeschakeld"
    },
    "empty": {
      "title": "Nog geen connectoren",
      "description": "Koppel een botaccount op een chatplatform, zodat mensen met een agent praten waar ze al werken."
    },
    "typePicker": {
      "title": "Kies een platform",
      "description": "Waarmee moet de agent verbinden?",
      "comingSoon": "Binnenkort",
      "fields_one": "{{count}} instelling",
      "fields_other": "{{count}} instellingen"
    },
    "form": {
      "newTitle": "Nieuwe {{type}}-connector",
      "newDescription": "Koppel een {{type}}-botaccount aan een agent.",
      "sections": {
        "general": "Algemeen",
        "agent": "Agent en tools",
        "connection": "Verbinding"
      },
      "name": "Naam",
      "enabled": "Ingeschakeld",
      "enabledHint": "Luister naar berichten en antwoord als de bot.",
      "agent": "Antwoordende agent",
      "agentHint": "Beantwoordt elk bericht dat de bot ontvangt.",
      "agentPlaceholder": "Kies een agent…",
      "agentArchived": "{{name}} (gearchiveerd)",
      "agentRequired": "Koppel een agent voordat je de connector inschakelt.",
      "mcp": "Extra integraties",
      "mcpHint": "Beschikbaar voor de agent in deze connector, naast zijn eigen integraties.",
      "mcpEmpty": "Nog geen integraties ingesteld.",
      "mcpSearch": "Integraties zoeken…",
      "mcpSelected_one": "{{count}} geselecteerd",
      "mcpSelected_other": "{{count}} geselecteerd",
      "secretStored": "Opgeslagen",
      "secretKeep": "Laat leeg om de opgeslagen waarde te behouden",
      "secretStoredHint": "Er is een waarde opgeslagen die nooit wordt getoond. Vul een nieuwe in om die te vervangen.",
      "numberInvalid": "Vul een getal van 0 of meer in.",
      "unavailable": "{{type}}-connectoren zijn nog niet beschikbaar. Je kunt de configuratie opslaan, maar de connector draait niet.",
      "runtime": "Status",
      "secretClear": "Wissen",
      "secretClearLabel": "Opgeslagen {{field}} wissen",
      "secretCleared": "Wordt verwijderd",
      "secretClearedHint": "De opgeslagen waarde wordt verwijderd zodra je opslaat.",
      "secretUndo": "Ongedaan maken"
    },
    "test": {
      "title": "Verbindingstest",
      "hint": "Controleert de configuratie en meldt zich aan met het bottoken.",
      "saveFirst": "Sla eerst je wijzigingen op; de test gebruikt de opgeslagen configuratie.",
      "action": "Verbinding testen",
      "running": "Bezig met testen…",
      "ok": "Aangemeld als {{name}}",
      "okNoName": "Inloggegevens geaccepteerd",
      "failed": "De verbindingstest is mislukt",
      "online": "OK",
      "offline": "Mislukt",
      "botId": "Botgebruikers-ID",
      "okNamed": "{{name}}: verbinding werkt",
      "failedNamed": "{{name}}: verbindingstest mislukt"
    },
    "fields": {
      "mattermost": {
        "websocket_url": {
          "label": "WebSocket-URL",
          "help": "WebSocket-endpoint van de Mattermost-server. De basis-URL van de REST API wordt hieruit afgeleid."
        },
        "bot_token": {
          "label": "Bottoken",
          "help": "Persoonlijk toegangstoken van het botaccount."
        },
        "bot_user_id": {
          "label": "Botgebruikers-ID",
          "help": "Optioneel; wordt automatisch uit het token bepaald."
        },
        "thread_memory_hours": {
          "label": "Threadgeheugen (uren)",
          "help": "Hoe lang het gespreksgeheugen van een thread na het laatste bericht bewaard blijft. 0 = verloopt nooit."
        },
        "error_message": {
          "label": "Foutantwoord",
          "help": "Antwoord dat wordt geplaatst als de agent niet kan antwoorden."
        }
      },
      "slack": {
        "bot_token": {
          "label": "Bottoken"
        },
        "app_token": {
          "label": "App-token"
        },
        "signing_secret": {
          "label": "Ondertekeningsgeheim"
        }
      },
      "telegram": {
        "bot_token": {
          "label": "Bottoken"
        }
      }
    },
    "conversations": {
      "title": "Gesprekken",
      "description": "Threads die de bot onthoudt. Het geheugen verloopt na de ingestelde inactieve tijd.",
      "back": "Alle connectoren",
      "search": "Gesprekken zoeken…",
      "empty": {
        "title": "Nog geen gesprekken",
        "description": "Threads verschijnen hier zodra mensen de bot een bericht sturen."
      },
      "select": {
        "title": "Kies een gesprek",
        "description": "Selecteer een thread om te lezen wat er is gezegd."
      },
      "thread": "Gesprek {{id}}",
      "inChannel": "in kanaal {{channel}}",
      "turns_one": "{{count}} beurt",
      "turns_other": "{{count}} beurten",
      "messages_one": "{{count}} opgeslagen bericht",
      "messages_other": "{{count}} opgeslagen berichten",
      "started": "Gestart",
      "lastActive": "Laatst actief",
      "threadId": "Thread-ID",
      "copyId": "Thread-ID kopiëren",
      "unknownSender": "Onbekende gebruiker",
      "forget": "Vergeten",
      "forgetTitle": "Dit gesprek vergeten?",
      "forgetDescription": "De bot verliest zijn geheugen van deze thread; het volgende bericht begint opnieuw. De rungeschiedenis blijft beschikbaar in Inzichten.",
      "forgotten": "Gespreksgeheugen gewist",
      "viewRuns": "Runs bekijken",
      "openRun": "Run openen",
      "loadOlder": "Eerdere berichten laden",
      "showPrompt": "Volledige prompt tonen",
      "hidePrompt": "Volledige prompt verbergen",
      "noTranscript": "Nog geen berichten vastgelegd voor deze thread.",
      "working": "Bezig…",
      "notPosted": "Niet in de chat geplaatst ({{reason}}).",
      "noReply": "Er is geen antwoord verstuurd.",
      "toolCalls_one": "{{count}} toolaanroep",
      "toolCalls_other": "{{count}} toolaanroepen",
      "backToList": "Gesprekken",
      "attachments": "Bijlagen",
      "attachmentsSkipped": "Niet opgeslagen: {{files}}",
      "live": "Live bijgewerkt",
      "liveHint": "Nieuwe berichten verschijnen zodra ze binnenkomen."
    }
  },
  "schedules": {
    "title": "Planningen",
    "description": "Voer automatiseringen volgens een rooster uit — wekelijks op vaste tijden of met een cron-expressie, in elke tijdzone.",
    "new": "Nieuwe planning",
    "newTitle": "Nieuwe planning",
    "formDescription": "Kies wanneer de planning afgaat en welke automatiseringen hij uitvoert.",
    "create": "Planning aanmaken",
    "created": "Planning “{{name}}” aangemaakt",
    "saved": "Planning “{{name}}” opgeslagen",
    "enabledToast": "Planning “{{name}}” ingeschakeld",
    "disabledToast": "Planning “{{name}}” gepauzeerd",
    "deleted": "Planning “{{name}}” verwijderd",
    "runStarted_one": "“{{name}}” gestart: {{count}} actie in de wachtrij",
    "runStarted_other": "“{{name}}” gestart: {{count}} acties in de wachtrij",
    "search": "Planningen zoeken…",
    "noDescription": "Geen beschrijving",
    "missingTarget": "Verwijderde automatisering #{{id}}",
    "moreActions_one": "+{{count}} extra",
    "moreActions_other": "+{{count}} extra",
    "notPlanned": "Niet gepland",
    "paused": "Gepauzeerd",
    "pausedHint": "Gepauzeerd — draait alleen als je hem handmatig start.",
    "lastOk": "Laatste uitvoering geslaagd",
    "lastFailed": "Laatste uitvoering mislukt",
    "toggle": "{{name}} inschakelen",
    "runNow": "Nu uitvoeren",
    "history": "Uitvoeringsgeschiedenis",
    "nextRun": "Volgende uitvoering",
    "viewRun": "Run bekijken",
    "viewRoom": "Ruimte bekijken",
    "toggleDetails": "Details tonen",
    "delete": "Planning verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "De planning en de uitvoeringsgeschiedenis worden verwijderd. De automatiseringen zelf blijven bestaan.",
    "columns": {
      "schedule": "Planning",
      "timing": "Wanneer",
      "actions": "Voert uit",
      "next": "Volgende",
      "last": "Laatste",
      "enabled": "Actief"
    },
    "empty": {
      "title": "Nog geen planningen",
      "description": "Planningen voeren automatiseringen automatisch uit, bijvoorbeeld een dagrapport om 08:00 op werkdagen."
    },
    "historyEmpty": {
      "title": "Nog geen uitvoeringen",
      "description": "Uitvoeringen verschijnen hier zodra de planning afgaat of handmatig wordt gestart."
    },
    "execStatus": {
      "queued": "In wachtrij",
      "running": "Bezig",
      "succeeded": "Geslaagd",
      "failed": "Mislukt"
    },
    "trigger": {
      "manual": "Handmatig gestart",
      "schedule": "Gepland"
    },
    "types": {
      "agent_automation": "Agent-automatisering",
      "team_automation": "Team-automatisering"
    },
    "describe": {
      "everyMinute": "Elke minuut",
      "everyNMinutes_one": "Elke minuut",
      "everyNMinutes_other": "Elke {{count}} minuten",
      "hourly": "Elk uur om :{{minute}}",
      "everyNHours_one": "Elk uur om :{{minute}}",
      "everyNHours_other": "Elke {{count}} uur om :{{minute}}",
      "at": "Om {{times}}",
      "everyDay": "elke dag",
      "weekdays": "op werkdagen",
      "weekends": "in het weekend",
      "onDays": "op {{days}}",
      "monthDays_one": "op dag {{days}} van de maand",
      "monthDays_other": "op dag {{days}} van de maand",
      "inMonths": "alleen in {{months}}",
      "custom": "Aangepaste cron-expressie",
      "never": "Geen tijden ingesteld"
    },
    "form": {
      "name": "Naam",
      "namePlaceholder": "Wekelijks verkooprapport",
      "description": "Beschrijving",
      "enabled": "Ingeschakeld",
      "enabledHint": "Gepauzeerde planningen behouden hun instellingen en kunnen nog handmatig worden uitgevoerd.",
      "when": "Wanneer",
      "whenHint": "Kies dagen en tijden, of schrijf een cron-expressie voor iets specifiekers.",
      "modeWeekly": "Dagen & tijden",
      "modeCron": "Cron-expressie",
      "days": "Dagen",
      "daysRequired": "Kies minstens één dag",
      "presetWeekdays": "Werkdagen",
      "presetEveryDay": "Elke dag",
      "times": "Tijden",
      "timesHint": "Lokale tijden in de tijdzone van de planning.",
      "timesRequired": "Voeg minstens één tijd toe",
      "timeInvalid": "Gebruik UU:MM (24-uurs)",
      "timeN": "Tijd {{n}}",
      "removeTime": "{{time}} verwijderen",
      "addTime": "Tijd toevoegen",
      "cron": "Cron-expressie",
      "cronHint": "minuut · uur · dag van de maand · maand · dag van de week — hooguit één keer per minuut.",
      "presets": "Voorbeelden",
      "timezone": "Tijdzone",
      "timezoneHint": "Laat op de standaard van de organisatie staan om de organisatie-instellingen te volgen.",
      "orgTimezone": "Standaard van de organisatie",
      "preview": "Voorbeeld",
      "previewIncomplete": "Kies minstens één dag en tijd",
      "nextRuns": "Volgende uitvoeringen ({{tz}})",
      "timezoneIs": "Tijden zijn in {{tz}}.",
      "actions": "Acties",
      "actionsHint": "Automatiseringen die elke keer starten als de planning afgaat, in deze volgorde.",
      "addAction": "Actie toevoegen",
      "actionsEmpty": "Voeg de eerste automatisering toe",
      "noTargets": "Maak eerst een automatisering — planningen voeren agent- of team-automatiseringen uit.",
      "actionsRequired": "Voeg minstens één actie toe",
      "target": "Automatisering",
      "targetPlaceholder": "Kies een automatisering…",
      "removeAction": "Actie {{n}} verwijderen",
      "fileParams": "Heeft bestandsparameters — kan niet worden gepland",
      "noParams": "Deze automatisering heeft geen parameters.",
      "paramsMissing": "Vul de verplichte parameters in: {{names}}"
    }
  },
  "evals": {
    "title": "Evaluaties",
    "description": "Test agents met vaste prompts, regelcontroles en een LLM-beoordelaar, volg het slagingspercentage in de tijd en vang regressies op.",
    "search": "Suites zoeken…",
    "newSuite": "Nieuwe suite",
    "editSuite": "Suite bewerken",
    "createSuite": "Suite aanmaken",
    "suiteFormDescription": "Een suite is een set testgevallen die tegen één agent draait.",
    "suiteCreated": "Suite “{{name}}” aangemaakt",
    "suiteSaved": "Suite “{{name}}” opgeslagen",
    "suiteDeleted": "Suite “{{name}}” verwijderd",
    "suiteActions": "Suite-acties",
    "openSuite": "Suite openen",
    "deleteSuite": "Suite verwijderen",
    "deleteSuiteTitle": "“{{name}}” verwijderen?",
    "deleteSuiteDescription": "Alle testgevallen, runs en resultaten van deze suite worden verwijderd.",
    "backToSuites": "Terug naar suites",
    "noDescription": "Geen beschrijving",
    "notRunYet": "Nog niet uitgevoerd",
    "needCases": "Voeg eerst een testgeval toe",
    "runSuite": "Suite uitvoeren",
    "runStarted": "Run #{{id}} gestart",
    "rerunStarted": "Herhaling #{{id}} gestart",
    "runDeleted": "Run #{{id}} verwijderd",
    "caseCreated": "Testgeval toegevoegd",
    "caseSaved": "Testgeval opgeslagen",
    "caseDeleted": "Testgeval verwijderd",
    "caseN": "Testgeval #{{id}}",
    "runN": "Run #{{id}}",
    "rerunOf": "Herhaling van #{{id}}",
    "seconds": "s",
    "fields": {
      "name": "Naam",
      "namePlaceholder": "Rooktests supportagent",
      "agent": "Te testen agent",
      "agentHint": "Runs gebruiken altijd de huidige configuratie van de agent.",
      "agentPlaceholder": "Kies een agent…",
      "description": "Beschrijving"
    },
    "columns": {
      "suite": "Testsuite",
      "agent": "Geteste agent",
      "cases": "Testgevallen",
      "passRate": "Geslaagd",
      "lastRun": "Laatste run",
      "case": "Testgeval",
      "checks": "Controles",
      "tags": "Labels",
      "timeout": "Time-out",
      "run": "Run",
      "status": "Toestand",
      "results": "Resultaten",
      "cost": "Kosten",
      "duration": "Duur",
      "started": "Gestart"
    },
    "empty": {
      "title": "Nog geen evaluatiesuites",
      "description": "Maak een suite, voeg een paar typische prompts toe met de antwoorden die je verwacht en voer hem uit na elke wijziging aan een agent."
    },
    "tabs": {
      "cases": "Testgevallen ({{count}})",
      "runs": "Uitvoeringen"
    },
    "searchCases": "Testgevallen zoeken…",
    "newCase": "Nieuw testgeval",
    "addCase": "Testgeval toevoegen",
    "caseFormDescription": "De prompt gaat naar de agent; de uitvoer moet aan elke ingestelde controle voldoen.",
    "deleteCase": "Testgeval verwijderen",
    "deleteCaseTitle": "“{{name}}” verwijderen?",
    "deleteCaseDescription": "Resultaten van eerdere runs voor dit testgeval worden ook verwijderd.",
    "casesEmpty": {
      "title": "Nog geen testgevallen",
      "description": "Voeg testprompts toe, of begin met een sjabloon zoals “blijft bij het onderwerp” of “weigert schadelijke verzoeken”."
    },
    "presetLabel": "Begin met een sjabloon",
    "presetHint": "Vult een prompt en controles in die je kunt aanpassen.",
    "presetPlaceholder": "Kies een sjabloon…",
    "presets": {
      "cleanRun": {
        "name": "Rooktest",
        "description": "Antwoordt zonder fouten"
      },
      "jsonOutput": {
        "name": "JSON-uitvoer",
        "description": "Geeft een kaal JSON-object terug"
      },
      "noSystemLeak": {
        "name": "Geen promptlek",
        "description": "Verraadt de systeemprompt niet"
      },
      "politeRefusal": {
        "name": "Weigert schadelijke verzoeken",
        "description": "Weigert duidelijk en beleefd"
      },
      "staysOnTopic": {
        "name": "Blijft bij het onderwerp",
        "description": "Beantwoordt de vraag zonder af te dwalen"
      },
      "conciseHelpful": {
        "name": "Beknopt en behulpzaam",
        "description": "Bruikbaar antwoord zonder opvulling"
      },
      "unknownHonest": {
        "name": "Geeft toe wat het niet weet",
        "description": "Verzint geen feiten"
      },
      "groundedAnswer": {
        "name": "Gebaseerd op kennis",
        "description": "Vat echte bronnen samen in plaats van te gokken"
      }
    },
    "caseFields": {
      "name": "Naam",
      "namePlaceholder": "Vraag over openingstijden",
      "input": "Invoerprompt",
      "inputHint": "Wordt als gebruikersbericht naar de agent gestuurd.",
      "assertions": "Controles",
      "assertionsHint": "Alle ingestelde controles moeten slagen. Tekstcontroles negeren hoofdletters.",
      "contains": "Moet bevatten",
      "notContains": "Mag niet bevatten",
      "onePerLine": "Eén zinsdeel per regel.",
      "regex": "Moet overeenkomen met reguliere expressie",
      "regexHint": "Rust-regexsyntaxis; gebruik (?i) om hoofdletters te negeren.",
      "judge": "Instructies voor de LLM-beoordelaar",
      "judgeHint": "Optioneel. Het beoordelingsmodel van de organisatie geeft het antwoord een score van 0 tot 1.",
      "judgePlaceholder": "Geslaagd als het antwoord vriendelijk is en de openingstijden noemt.",
      "threshold": "Slagingsdrempel beoordelaar",
      "thresholdHint": "Minimale score (0–1) om te slagen.",
      "expectReply": "Antwoord",
      "expectReplyHint": "Of een chatkoppeling het antwoord zou plaatsen. Stil: de agent moet zwijgen (antwoordt met [[no_reply]]).",
      "expectReplyOptions": {
        "any": "Maakt niet uit",
        "reply": "Moet antwoorden",
        "silent": "Moet stil blijven"
      },
      "timeout": "Time-out",
      "tags": "Labels",
      "tagsPlaceholder": "rooktest, veiligheid…"
    },
    "checks": {
      "contains_one": "bevat {{count}}",
      "contains_other": "bevat {{count}}",
      "notContains_one": "sluit {{count}} uit",
      "notContains_other": "sluit {{count}} uit",
      "regex": "regex-patroon",
      "judge": "beoordelaar ≥ {{threshold}}",
      "replies": "antwoordt",
      "silent": "blijft stil",
      "toolCalls_one": "verwacht {{count}} aanroep",
      "toolCalls_other": "verwacht {{count}} aanroepen",
      "forbiddenCalls_one": "verbiedt {{count}} aanroep",
      "forbiddenCalls_other": "verbiedt {{count}} aanroepen",
      "none": "Geen controles"
    },
    "runStatus": {
      "pending": "In wachtrij",
      "running": "Bezig",
      "done": "Klaar",
      "error": "Fout"
    },
    "resultStatus": {
      "pass": "Geslaagd",
      "fail": "Gezakt",
      "error": "Fout"
    },
    "passRate": "Slagingspercentage",
    "passOf": "{{pass}} van {{total}} geslaagd",
    "results": "Resultaten",
    "passCount_one": "{{count}} geslaagd",
    "passCount_other": "{{count}} geslaagd",
    "failCount_one": "{{count}} gezakt",
    "failCount_other": "{{count}} gezakt",
    "errorCount_one": "{{count}} fout",
    "errorCount_other": "{{count}} fouten",
    "duration": "Duur",
    "cost": "Kosten",
    "trend": "Slagingspercentage door de tijd",
    "waiting": "Wachten op een worker…",
    "progress": "{{done}} van {{total}} testgevallen klaar",
    "progressLabel": "Voortgang van de run",
    "inFlight_one": "{{count}} testgeval bezig",
    "inFlight_other": "{{count}} testgevallen bezig",
    "caseRunning": "Bezig",
    "regressionTitle": "Regressie gevonden",
    "regressionText": "Het slagingspercentage daalde van {{from}} naar {{to}} ({{points}} punten) ten opzichte van run #{{id}}.",
    "runFailed": "De run is mislukt",
    "filterAll": "Alle ({{count}})",
    "filterFailed": "Niet geslaagd ({{count}})",
    "compareWithPrevious": "Vergelijken met vorige",
    "rerunFailed_one": "{{count}} mislukt testgeval opnieuw uitvoeren",
    "rerunFailed_other": "{{count}} mislukte testgevallen opnieuw uitvoeren",
    "deleteRun": "Run verwijderen",
    "deleteRunTitle": "Run #{{id}} verwijderen?",
    "deleteRunDescription": "De resultaten worden verwijderd; de agent-runs blijven in het runlogboek.",
    "noResultsYet": "Resultaten verschijnen hier zodra testgevallen klaar zijn.",
    "allPassed": "Alle testgevallen zijn geslaagd.",
    "noResults": "Deze run heeft geen resultaten.",
    "judgeScore": "beoordelaar {{score}}",
    "judge": "Beoordelaar",
    "judgeWithScore": "Beoordelaar · score {{score}}",
    "input": "Invoerprompt",
    "failureReasons": "Waarom het mislukte",
    "output": "Uitvoer",
    "replySuppressed": "Niet in de chat geplaatst ({{reason}}). Ruwe uitvoer hieronder, voor debugging:",
    "reasoning": "Redenering",
    "replySuppressedNoOutput": "Niet in de chat geplaatst ({{reason}}).",
    "suppressReason": {
      "empty": "lege uitvoer",
      "sentinel": "no-reply-markering",
      "reasoning_only": "alleen redenering"
    },
    "noOutput": "Geen uitvoer.",
    "viewAgentRun": "Agent-run bekijken",
    "selectForCompare": "Selecteren om te vergelijken",
    "selectRun": "Run #{{id}} selecteren",
    "selectTwo": "Selecteer twee runs om ze te vergelijken.",
    "twoSelected": "Twee runs geselecteerd.",
    "compareSelected": "Vergelijken",
    "runsEmpty": {
      "title": "Nog geen runs",
      "description": "Voer de suite uit om te zien hoe de agent het op elk testgeval doet."
    },
    "compare": {
      "title": "Runs vergelijken",
      "description": "Hoe elk testgeval veranderde tussen twee runs.",
      "baseline": "Uitgangspunt",
      "candidate": "Vergeleken run",
      "onlyChanged": "Alleen gewijzigde testgevallen",
      "noChanges": "Geen enkel testgeval veranderde tussen deze runs.",
      "noCases": "Deze runs hebben geen resultaten om te vergelijken.",
      "notRun": "Niet uitgevoerd",
      "counts": {
        "regressed_one": "{{count}} achteruitgegaan",
        "regressed_other": "{{count}} achteruitgegaan",
        "fixed_one": "{{count}} opgelost",
        "fixed_other": "{{count}} opgelost",
        "changed_one": "{{count}} gewijzigd",
        "changed_other": "{{count}} gewijzigd",
        "added_one": "{{count}} alleen in vergeleken run",
        "added_other": "{{count}} alleen in vergeleken run",
        "removed_one": "{{count}} alleen in uitgangspunt",
        "removed_other": "{{count}} alleen in uitgangspunt",
        "same_one": "{{count}} ongewijzigd",
        "same_other": "{{count}} ongewijzigd"
      },
      "change": {
        "regressed": "Achteruit",
        "fixed": "Opgelost",
        "changed": "Gewijzigd",
        "added": "Nieuw",
        "removed": "Ontbreekt",
        "same": "Ongewijzigd"
      }
    },
    "alerts": {
      "title": "Regressies",
      "drop": "−{{points}} ptn"
    },
    "mcp": {
      "section": "Integraties en toolaanroepen",
      "sectionHint": "Evaluaties maken nooit contact met de integraties van de agent: elke tool wordt nagebootst. Controleer welke tools de agent aanroept.",
      "mocked": "Integraties nagebootst",
      "mockedHint": "Evaluaties maken nooit contact met de MCP-integraties of ingebouwde toolsets van de agent: elke toolaanroep wordt nagebootst en vastgelegd.",
      "stubs": "Vaste antwoorden",
      "stubsHint": "Optioneel JSON-object: toolnaam → antwoord, om het gesprek te sturen. Andere tools geven {\"ok\": true}.",
      "expected": "Verwachte toolaanroepen",
      "expectedHint": "JSON-array van {\"tool\", \"args_contains\"}. Elk moet geslaagd aangeroepen worden; args_contains is optioneel (per sleutel, waarden exact; null = leeg of niet meegegeven).",
      "forbidden": "Verboden toolaanroepen",
      "forbiddenHint": "JSON-array in hetzelfde formaat. De case faalt als de agent er een probeert.",
      "invalidStubs": "Vul een JSON-object in, bijv. {\"tool_name\": {\"ok\": true}}.",
      "invalidToolCalls": "Vul een JSON-array in van {\"tool\": \"…\", \"args_contains\": {…}}.",
      "toolCalls": "Toolaanroepen",
      "missingTitle_one": "{{count}} integratie heeft geen opgeslagen toollijst",
      "missingTitle_other": "{{count}} integraties hebben geen opgeslagen toollijst",
      "missingText": "{{names}}: evaluaties kunnen alleen de tools nabootsen die een case noemt. Ververs de toollijsten om al hun tools na te bootsen.",
      "refresh": "Toollijsten verversen",
      "refreshed": "Toollijsten ververst",
      "refreshedPartly": "Sommige toollijsten konden niet worden ververst: {{names}}"
    }
  },
  "teams": {
    "title": "Agentteams",
    "detailTitle": "Teamdetails",
    "description": "Groepen agents die samenwerken in werkplekruimtes, onder leiding van één teamleider.",
    "new": "Nieuw team",
    "search": "Teams zoeken…",
    "noDescription": "Geen beschrijving",
    "noMembers": "Nog geen leden",
    "memberCount_one": "{{count}} lid",
    "memberCount_other": "{{count}} leden",
    "concurrency_one": "Maximaal {{count}} lid werkt tegelijk",
    "concurrency_other": "Maximaal {{count}} leden werken tegelijk",
    "ready": "Gereed",
    "notReady": "Niet gereed",
    "backToList": "Terug naar teams",
    "delete": "Team verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "Het team, de leden en de automatiseringen worden verwijderd.",
    "deleteInUse_one": "De {{count}} ruimte wordt gestopt en houdt het gesprek. Leden en automatiseringen worden verwijderd.",
    "deleteInUse_other": "De {{count}} ruimtes worden gestopt en houden hun gesprekken. Leden en automatiseringen worden verwijderd.",
    "empty": {
      "title": "Stel je eerste team samen",
      "description": "Een team combineert agents en eenvoudige rollen onder een teamleider die het werk in een ruimte verdeelt."
    },
    "tabs": {
      "teams": "Alle teams",
      "members": "Leden",
      "rooms": "Ruimtes",
      "automations": "Automatiseringen"
    },
    "columns": {
      "team": "Teamnaam",
      "members": "Leden",
      "leader": "Teamleider",
      "status": "Toestand",
      "rooms": "Ruimtes",
      "updated": "Bijgewerkt"
    },
    "actions": {
      "open": "Team openen"
    },
    "toast": {
      "created": "Team “{{name}}” aangemaakt",
      "saved": "Team “{{name}}” opgeslagen",
      "deleted": "Team “{{name}}” verwijderd",
      "memberAdded": "{{name}} is aan het team toegevoegd",
      "memberSaved": "{{name}} bijgewerkt",
      "memberRemoved": "{{name}} is uit het team verwijderd",
      "leader": "{{name}} leidt nu het team"
    },
    "form": {
      "newTitle": "Nieuw team",
      "editTitle": "Team bewerken",
      "description": "Leden en automatiseringen beheer je op de teampagina.",
      "create": "Team aanmaken",
      "name": "Naam",
      "namePlaceholder": "Klantenservice",
      "teamDescription": "Beschrijving",
      "teamDescriptionHint": "Waar het team voor is. De AI-teambouwer leest dit ook.",
      "concurrency": "Parallelle leden",
      "concurrencyHint": "Hoeveel leden tegelijk in een ruimte mogen werken (1–16)."
    },
    "kinds": {
      "agent": "AI-agent",
      "simple": "Eenvoudig"
    },
    "member": {
      "add": "Lid toevoegen",
      "addTitle": "Lid toevoegen",
      "addDescription": "Voeg een bestaande agent toe of een eenvoudige rol met een eigen prompt en model.",
      "editDescription": "Wijzigingen gelden direct in de ruimtes van het team.",
      "kind": "Soort",
      "kindHint": {
        "agent": "Gebruikt een agent uit Studio, met diens prompt, model, tools en skills.",
        "simple": "Een lichte rol: een prompt, een model en een temperatuur, zonder tools."
      },
      "agent": "Gekoppelde agent",
      "agentHint": "Prompt, model en tools komen van deze agent.",
      "agentPlaceholder": "Kies een agent",
      "displayName": "Naam in ruimtes",
      "displayNameAgentHint": "Optioneel. Laat leeg om de naam van de agent te gebruiken.",
      "displayNamePlaceholder": "Onderzoeker",
      "rolePrompt": "Rolprompt",
      "rolePromptHint": "De systeemprompt waarmee dit lid werkt.",
      "rolePromptPlaceholder": "Je zoekt feiten uit en vermeldt je bronnen…",
      "model": "Taalmodel",
      "modelPlaceholder": "Kies een model",
      "temperature": "Temperatuur",
      "temperatureHint": "Lager is gerichter, hoger is creatiever.",
      "invocation": "Wanneer inschakelen",
      "invocationHint": "Vertelt de teamleider wanneer werk naar dit lid gaat.",
      "invocationPlaceholder": "Vraag om onderzoek of het controleren van feiten.",
      "leader": "Teamleider",
      "leaderHint": "De teamleider plant het werk en delegeert aan de anderen. De huidige teamleider treedt terug.",
      "leaderFirst": "Het eerste lid leidt altijd het team.",
      "leaderCurrent": "Dit lid leidt het team. Maak een ander lid teamleider om dat te wijzigen."
    },
    "members": {
      "description": "De teamleider coördineert; de volgorde is de volgorde waarin leden in ruimtes verschijnen.",
      "leader": "Teamleider",
      "linkedAgent": "Gekoppeld aan {{name}}",
      "missingAgent": "Gekoppelde agent ontbreekt",
      "simpleModel": "{{model}} · temperatuur {{temperature}}",
      "missingModel": "Geen model gekozen",
      "makeLeader": "Teamleider maken",
      "up": "Omhoog",
      "down": "Omlaag",
      "moveUp": "{{name}} omhoog verplaatsen",
      "moveDown": "{{name}} omlaag verplaatsen",
      "actions": "Acties voor {{name}}",
      "remove": "Verwijderen",
      "removeTitle": "{{name}} verwijderen?",
      "removeDescription": "Het lid verlaat het team.",
      "removeInRooms_one": "Het lid verlaat het team en stopt met werken in de {{count}} ruimte.",
      "removeInRooms_other": "Het lid verlaat het team en stopt met werken in de {{count}} ruimtes.",
      "notReady": "Dit team kan nog geen ruimtes starten",
      "noLeader": "Markeer precies één lid als teamleider.",
      "multipleLeaders": "Meer dan één lid is teamleider; houd er precies één.",
      "emptyTitle": "Nog geen leden",
      "emptyDescription": "Voeg zelf agents toe of laat de AI-teambouwer een samenstelling voorstellen."
    },
    "designer": {
      "buildAction": "Bouwen met AI",
      "tweakAction": "Bijstellen met AI",
      "buildTitle": "AI-teambouwer",
      "tweakTitle": "Team bijstellen met AI",
      "buildDescription": "Beschrijf wat “{{team}}” moet doen. De agent stelt rollen voor en voegt ze toe als eenvoudige leden.",
      "tweakDescription": "Vraag om wijzigingen in de samenstelling van “{{team}}”: namen, rollen, teamleider, modellen of instructies.",
      "buildEmpty": "Leden worden toegevoegd terwijl de agent werkt; je kunt ze daarna bewerken of verwijderen.",
      "tweakEmpty": "Wijzigingen worden doorgevoerd terwijl de agent werkt; de ledenlijst achter dit paneel werkt live bij.",
      "agent": "Uitvoerende agent",
      "agentPlaceholder": "Kies een agent",
      "memberModel": "Model voor nieuwe leden",
      "memberTemperature": "Temperatuur voor nieuwe leden",
      "message": "Bericht",
      "buildPlaceholder": "Beschrijf het team dat je nodig hebt…",
      "tweakPlaceholder": "Beschrijf de wijziging…",
      "send": "Versturen",
      "stop": "Stoppen",
      "reset": "Opnieuw beginnen",
      "working": "Bezig…",
      "failed": "De run is mislukt.",
      "cancelled": "Gestopt.",
      "interrupted": "De verbinding werd verbroken voordat de run klaar was.",
      "openRun": "Run openen",
      "starters": {
        "build1": "Stel een klein team (3–4 leden) voor met dit doel, met een duidelijke teamleider.",
        "build2": "Voeg een kritische reviewer toe die het werk van de anderen controleert voordat het definitief is.",
        "tweak1": "Bekijk de samenstelling en maak de instructies van elk lid scherper.",
        "tweak2": "Laat de teamleider meer delegeren en zelf minder schrijven."
      }
    },
    "phases": {
      "agent_running": "Aan het werk",
      "awaiting_user_input": "Wacht op invoer",
      "idle_active": "Inactief",
      "turn_budget_exhausted": "Budget op",
      "paused": "Gepauzeerd"
    },
    "rooms": {
      "stats": {
        "rooms": "Ruimtes",
        "active": "Actieve ruimtes",
        "messages": "Berichten",
        "lastActivity": "Laatste activiteit"
      },
      "contributors": "Berichten per lid",
      "search": "Ruimtes zoeken…",
      "columns": {
        "room": "Ruimte",
        "phase": "Toestand",
        "messages": "Berichten",
        "members": "Leden",
        "lastMessage": "Laatste bericht"
      },
      "emptyTitle": "Nog geen ruimtes",
      "emptyDescription": "Ruimtes die met dit team in de werkplek zijn gestart, handmatig of via een automatisering, verschijnen hier."
    },
    "automations": {
      "title": "Teamautomatiseringen",
      "newTitle": "Nieuwe teamautomatisering",
      "create": "Automatisering aanmaken",
      "formDescription": "Een herbruikbare opdracht die een ruimte met het team start, vanaf hier, via een planning of via de webhook.",
      "team": "Bijbehorend team",
      "teamPlaceholder": "Kies een team",
      "emptyTitle": "Geen teamautomatiseringen",
      "emptyDescription": "Maak van een terugkerend verzoek een opdracht met parameters die een ruimte met het team opent.",
      "deleteDescription": "Planningen en koppelingen die deze automatisering starten, werken dan niet meer.",
      "needsWorkplace": "Voor het uitvoeren van automatiseringen is toegang tot de werkplek nodig.",
      "apiDescription": "Laat andere systemen een ruimte starten met een HTTP-verzoek.",
      "runDescription": "Vul de parameters in. Er opent een nieuwe ruimte met {{team}} die de opdracht ontvangt.",
      "startRoom": "Ruimte starten",
      "started": "Ruimte gestart",
      "startedHint": "Het team werkt aan de opdracht; open de ruimte in de werkplek om mee te kijken.",
      "columns": {
        "automation": "Automatisering",
        "team": "Teamnaam",
        "setup": "Inrichting",
        "runs": "Uitvoeringen"
      },
      "brief": {
        "title": "Opdracht",
        "description": "Waarmee de ruimte begint. Gebruik parameters als plaatshouders.",
        "roomTitle": "Titel van de ruimte",
        "roomTitleHint": "Optioneel. Standaard de naam van de automatisering.",
        "roomTitlePlaceholder": "Onderzoek: {{topic}}",
        "message": "Openingsbericht",
        "messageHint": "Wordt als eerste bericht in de ruimte geplaatst; de teamleider pakt het op.",
        "instructions": "Instructies voor de ruimte",
        "instructionsHint": "Extra instructies die elk lid in de ruimte ziet."
      },
      "room": {
        "title": "Instellingen van de ruimte",
        "description": "Instellingen voor ruimtes die deze automatisering start. Lege velden gebruiken de gebruikelijke standaardwaarden.",
        "defaults": "Standaardinstellingen",
        "overrides_one": "{{count}} instelling",
        "overrides_other": "{{count}} instellingen",
        "contextMax": "Berichten in context",
        "contextMaxHint": "Recente berichten die leden zien (10–500, standaard 100).",
        "turnBudget": "Beurtenbudget",
        "turnBudgetHint": "Maximaal aantal beurten van leden voordat de ruimte stopt.",
        "noLimit": "Geen limiet",
        "compression": "Oudere berichten comprimeren",
        "compressionHint": "Vat berichten buiten het contextvenster samen.",
        "compressionKb": "Samenvattingen in de kennisbank opslaan",
        "compressionKbHint": "Zo kunnen leden eerdere delen van het gesprek doorzoeken.",
        "hitl": "Mens in de lus",
        "hitlHint": "De teamleider kan pauzeren en iemand iets vragen voordat het verdergaat.",
        "hitlCondition": "Wanneer vragen",
        "hitlConditionPlaceholder": "Voordat er iets naar een klant gaat.",
        "guardrails": "Vangrails",
        "guardrailsHint": "Eén regel per regel; elk lid moet zich eraan houden.",
        "guardrailsPlaceholder": "Deel nooit persoonsgegevens.",
        "data": "Gegevens van de ruimte",
        "dataHint": "Feiten die leden kunnen lezen, zoals een klant- of projectnaam.",
        "dataAdd": "Waarde toevoegen",
        "sentry": "Sentry-organisatie",
        "sentryHint": "Organisatie-slug voor Sentry-tools in deze ruimte."
      },
      "toast": {
        "created": "Automatisering “{{name}}” aangemaakt",
        "saved": "Automatisering “{{name}}” opgeslagen",
        "deleted": "Automatisering “{{name}}” verwijderd"
      },
      "history": {
        "open": "Uitvoergeschiedenis",
        "title": "Uitvoeringen van {{name}}",
        "description": "Ruimtes die deze automatisering startte, nieuwste eerst.",
        "emptyTitle": "Nog geen uitvoeringen",
        "emptyDescription": "Voer de automatisering uit of roep de webhook aan om een ruimte te starten.",
        "turns_one": "{{formatted}} beurt",
        "turns_other": "{{formatted}} beurten"
      }
    }
  }
}
